import { Component, OnInit } from '@angular/core';
import { FormGroup, Validators, FormControl  } from '@angular/forms';
import { RegistrationService } from '../../services/registration.service';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-newlogin',
  templateUrl: './newlogin.component.html',
  styleUrls: ['./newlogin.component.scss']
})
export class NewloginComponent implements OnInit {

  show:boolean;
  allDetails: any;
  adminloginForm: FormGroup;

  constructor(private registrationService: RegistrationService, private router: Router, private spinner: NgxSpinnerService) { }

  ngOnInit() { 

  this.adminloginForm = new FormGroup({
    codenumber: new FormControl('', [Validators.required]),
    password: new FormControl('', Validators.required)
  });
} 

password() {
  this.show = !this.show;
}

submit() {
  if(this.adminloginForm.valid){
    this.spinner.show();
    // console.log(this.adminloginForm.value);
    const data = this.adminloginForm.value;
    this.registrationService.adminLogin(data).then(res => {
      this.spinner.hide();
      // console.log(res);
      if(res.status == "success") {
      this.allDetails = res;
      localStorage.setItem('admLoginDetails', JSON.stringify(this.allDetails));
      this.router.navigateByUrl('admdashboard');
      }
  });
}
}

}



// WEBPACK FOOTER //
// ./src/app/admin/newlogin/newlogin.component.ts